<template>
  <el-row style="text-align:center;">
    <el-col>
      <div class="imgBox" :style="{width: size, height: size}">
<!--        <img :src="img" alt="" ref="img" class="imgStyle"/>-->
        <img style="width: 100%; height: 100%; object-fit: contain;" ref="img" :src="img" alt=""/>
      </div>
      <el-button-group style="margin: 20px auto;">
        <ElButtons type="info" icon="RefreshLeft" iconSize="18" @click="rotateFun(-90)" :plain="true" :round="true"></ElButtons>
        <ElButtons type="info" icon="Rank" iconSize="18" @click="showImg(img)" :plain="true" :round="true"></ElButtons>
        <ElButtons type="info" icon="RefreshRight" iconSize="18" @click="rotateFun(90)" :plain="true" :round="true"></ElButtons>
      </el-button-group>
    </el-col>
  </el-row>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "ImgView",
  props: {
    src: {
      type: String,
      default: ''
    },
     size: {
        type: String,
        default: '400px'
     }
  },
  data() {
    return {
      img: this.src,
      deg: 0,

    }
  },
    watch: {
      src() {
          this.img = this.src
      }
    },
  methods: {

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    //图片旋转
    rotateFun(val){
      this.deg += val;
      this.$refs.img.style.transform = "rotate(" + this.deg + "deg)";
    },

  },
  mounted() {
    // let image = new Image();
    // image.src = this.img;
    // if(image.width >= image.height) {
    //   this.$refs.img.style.width = '100%'
    // }else{
    //   this.$refs.img.style.height = '100%'
    // }
  },
}
</script>

<style scoped>
.imgBox {
  /*margin: 0 auto;*/
  /*overflow: hidden;*/
  /*width: 400px;*/
  /*height: 400px;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  background-color: #ddd;
  margin: 0 16px;
}
.imgStyle {
  display: inline-block;
  vertical-align: middle;
}
</style>
